// Model
import { LayoutState } from './layout.state';

// Actions
import * as fromActions from './layout.actions';

const defaultState: LayoutState = {
    collapsed: false,
    asidePrimaryId: null,
    asideSecondaryId: null,
    asideOpenedMenu: false,
    anonymous: false,
};

export type Action = fromActions.All;

export function LayoutReducer(state = defaultState, action: any) {
    // console.log(state, action);
    switch (action.type) {
        case fromActions.TOGGLE_COLLAPSED:
            return {
                ...state,
                collapsed: !state.collapsed,
            };

        case fromActions.SET_COLLAPSED:
            return {
                ...state,
                collapsed: action.collapsed,
            };

        case fromActions.SHOW_ASIDE_PRIMARY:
            return {
                ...state,
                asidePrimaryId: action.idLayout,
            };

        case fromActions.CLOSE_ASIDE_PRIMARY:
            return {
                ...state,
                asidePrimaryId: null,
            };

        case fromActions.SHOW_ASIDE_SECONDARY:
            return {
                ...state,
                asideSecondaryId: action.idLayout,
                params: action.params,
            };

        case fromActions.CLOSE_ASIDE_SECONDARY:
            return {
                ...state,
                asideSecondaryId: null,
            };

        case fromActions.SHOW_MENU:
            return {
                ...state,
                asideOpenedMenu: true,
            };
        case fromActions.TOGGLE_MENU:
            return {
                ...state,
                asideOpenedMenu: !state.asideOpenedMenu,
            };

        case fromActions.CLOSE_MENU:
            return {
                ...state,
                asideOpenedMenu: false,
                asidePrimaryId: null,
                asideSecondaryId: null,
            };

        case fromActions.ANONYMOUS:
            return {
                ...state,
                anonymous: true,
            };

        case fromActions.ANONYMOUS_OFF:
            return {
                ...state,
                anonymous: false,
            };

        case fromActions.BACK:
            return {
                ...state,
                asidePrimaryId: null,
                asideSecondaryId: null,
            };

        default:
            return state;
    }
}
